import { components } from './components.theme';
import { pages } from './pages.theme';
import { typography } from './typography.theme';
import { colors } from './colors.theme';
import { general } from './general.theme';

export const theme = {
    colors,
    components,
    pages,
    typography,
    general,
};
